import { render, staticRenderFns } from "./UploadFields.vue?vue&type=template&id=5fe43478&scoped=true&"
import script from "./UploadFields.vue?vue&type=script&lang=js&"
export * from "./UploadFields.vue?vue&type=script&lang=js&"
import style0 from "./UploadFields.vue?vue&type=style&index=0&id=5fe43478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe43478",
  null
  
)

export default component.exports